<template>
	<div>
		<div class="logged-in" @click="handleAccountClick" v-if="userStore.isLoggedIn">
			<Spinner v-if="isMounted && userStore.loginProgress" size="sm" color="gold" />
			<FontAwesomeIcon :icon="faUserCog" v-else />
		</div>

		<div class="not-logged-in" @click="handleLoginClick" v-if="!userStore.isLoggedIn">
			<BasicButton color="dark" class="not-logged-in__button">
				{{ $t('WEBAPP_NAVBAR_SIGN_IN_BUTTON') }}
			</BasicButton>

			<FontAwesomeIcon :icon="faUserCog" class="not-logged-in__icon" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { faUserCog } from '@fortawesome/free-solid-svg-icons';

import BasicButton from '@/ui-components/BasicButton.vue';
import Spinner from '@/ui-components/Spinner.vue';
import { AccountModal, SettingsModal } from '@/lazy-load-components';

import { ModalHelper } from '@/helpers/vfm/modal-helper';

import { useUserStore } from '@/stores/pinia/useUserStore';

import { useMounted } from '@vueuse/core';

const userStore = useUserStore();

const isMounted = useMounted();

function handleAccountClick() {
	ModalHelper.openModal(SettingsModal, {}, { id: 'settings' });
}

function handleLoginClick() {
	ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, []);
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.logged-in {
	height: 100%;
	padding: 0 15px;
	display: flex;
	align-items: center;
	color: var(--jw-color-primary);
	font-size: 18px;
}

.not-logged-in {
	height: 100%;
	display: flex;
	align-items: center;

	&__button {
		@media (max-width: $breakpoint-two-rows) {
			display: none;
		}
		//STARTER_PAGE_EXP
		&.ghost {
			padding-inline: 24px;
			border: none;
			border-radius: 8px;
			font-weight: 700;
			font-size: 14px;
		}
		//STARTER_PAGE_EXP
	}

	&__icon {
		display: none;
		font-size: 16px;
		cursor: pointer;

		@media (max-width: $breakpoint-two-rows) {
			display: block;
		}
	}

	@media (max-width: $breakpoint-two-rows) {
		padding: 0 15px;
	}
}
</style>
